// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1V5Nz","errorLogs":"styles_errorLogs__3iFxJ"};